import React from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Button, Header, Icon, Label, Loader, Message, Menu, Segment, Table } from 'semantic-ui-react'

import { fetchEntity } from 'actions/entities'
import { previewSubscriptionInvoice } from 'actions/billing'
import CancelSubscriptionItem from 'components/superuser/billing/CancelSubscriptionItem'
import PauseSubscriptionItem from 'components/superuser/billing/PauseSubscriptionItem'
import ResumeSubscriptionItem from 'components/superuser/billing/ResumeSubscriptionItem'
import { addressLines } from 'components/superuser/billing/address'

import { getBillingSubscription } from 'selectors/billing'

const today = () => new Date().toISOString().slice(0, 10)

class SubscriptionDetail extends React.Component {
  state = { preview: null, previewLoading: false, error: null }

  componentDidMount () {
    this.props.fetch(this.props.subscriptionId)
  }

  runPreview = () => {
    this.setState({ previewLoading: true, preview: null })
    this.props.preview(this.props.subscriptionId, today())
      .then((preview) => this.setState({ preview, previewLoading: false }))
      .catch((error) => this.setState({ error, previewLoading: false }))
  }

  render () {
    const { billingSubscription: sub } = this.props
    const { preview, previewLoading, error } = this.state

    if (error) return <Message negative>{JSON.stringify(error)}</Message>
    if (!sub) return <Loader active inline="centered"/>

    return (
      <div>
        <Header as="h2">
          Subscription #{sub.id}
          <Header.Subheader>
            {sub.billableName || `${sub.billableType} #${sub.billableId}`} · started {sub.startsOn}
          </Header.Subheader>
        </Header>

        <Segment>
          <Label color="blue">{sub.status}</Label>
          <Menu compact icon borderless secondary size="large" style={{ marginLeft: 8 }}>
            <PauseSubscriptionItem billingSubscription={sub}/>
            <ResumeSubscriptionItem billingSubscription={sub}/>
            <CancelSubscriptionItem billingSubscription={sub}/>
          </Menu>
          <Button size="small" as={NavLink} to={Routes.edit_superuser_billing_subscription_path({ id: sub.id })}>
            <Icon name="edit"/> Edit
          </Button>
        </Segment>

        <Segment>
          <Header as="h3">
            Preview next invoice
            <Button floated="right" primary onClick={this.runPreview} loading={previewLoading}>Run preview</Button>
          </Header>
          {preview && (
            <Table compact>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Period</Table.Cell>
                  <Table.Cell>
                    {preview.period_start} → {preview.period_end}
                    {preview.period_open
                      ? <Label size="mini" color="yellow" style={{ marginLeft: 8 }}>open — not billable yet</Label>
                      : <Label size="mini" color="green" style={{ marginLeft: 8 }}>closed — would bill now</Label>}
                  </Table.Cell>
                </Table.Row>
                <Table.Row><Table.Cell>Amount</Table.Cell><Table.Cell><strong>€ {Number(preview.amount).toFixed(2)}</strong></Table.Cell></Table.Row>
                <Table.Row><Table.Cell>Waived</Table.Cell><Table.Cell>{preview.waived ? 'yes' : 'no'}</Table.Cell></Table.Row>
                <Table.Row><Table.Cell>Usage</Table.Cell><Table.Cell><pre>{JSON.stringify(preview.usage_snapshot, null, 2)}</pre></Table.Cell></Table.Row>
                <Table.Row><Table.Cell>Lines</Table.Cell><Table.Cell><pre>{JSON.stringify(preview.line_items, null, 2)}</pre></Table.Cell></Table.Row>
              </Table.Body>
            </Table>
          )}
        </Segment>

        <Segment>
          <Header as="h3">Billing details</Header>
          <Table compact definition>
            <Table.Body>
              <Table.Row><Table.Cell>Plan</Table.Cell><Table.Cell>{sub.planName || `#${sub.planId}`}</Table.Cell></Table.Row>
              <Table.Row><Table.Cell>Billing email</Table.Cell><Table.Cell>{sub.billingEmail}</Table.Cell></Table.Row>
              <Table.Row><Table.Cell>VAT ID</Table.Cell><Table.Cell>{sub.billingVatId}</Table.Cell></Table.Row>
              <Table.Row><Table.Cell>Peppol ID</Table.Cell><Table.Cell>{sub.peppolId} {sub.deliverViaPeppol && <Label color="green" size="mini">deliver</Label>}</Table.Cell></Table.Row>
              <Table.Row><Table.Cell>Address</Table.Cell><Table.Cell>{addressLines(sub.billingAddress).map((line, i) => <div key={i}>{line}</div>)}</Table.Cell></Table.Row>
            </Table.Body>
          </Table>
        </Segment>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  billingSubscription: getBillingSubscription(ownProps.subscriptionId)(state)
})

const mapDispatchToProps = (dispatch) => ({
  fetch: (id) => dispatch(fetchEntity('billingSubscriptions', id)),
  preview: (id, runDate) => dispatch(previewSubscriptionInvoice(id, runDate))
})

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionDetail)
